import React from "react";
import PropTypes from "prop-types";
import RichContentMap from "./RichContentMap";
import RichContentImages from "./RichContentImages";
const RichChatBubble = props => {
  const msg = props.data;
  switch (msg.type) {
    case "images":
      return /*#__PURE__*/React.createElement("div", {
        className: "chat-bubble tall"
      }, /*#__PURE__*/React.createElement(RichContentImages, {
        images: msg.content.images
      }));
    case "delivery-map":
      return /*#__PURE__*/React.createElement("div", {
        className: "chat-bubble tall"
      }, /*#__PURE__*/React.createElement(RichContentMap, {
        destination: props.data.content.deliveryMap.destination
      }));
    case "ofd-map":
      return /*#__PURE__*/React.createElement("div", {
        className: "chat-bubble tall"
      }, /*#__PURE__*/React.createElement(RichContentMap, {
        origin: props.data.content.map.origin,
        destination: props.data.content.map.destination
      }));
    default:
  }
};
RichChatBubble.propTypes = {
  data: PropTypes.object
};
export default RichChatBubble;